import { render, staticRenderFns } from "./AamsRegSealUsageApprovalDetail.vue?vue&type=template&id=65cd04a2&scoped=true&"
import script from "./AamsRegSealUsageApprovalDetail.vue?vue&type=script&lang=js&"
export * from "./AamsRegSealUsageApprovalDetail.vue?vue&type=script&lang=js&"
import style0 from "./AamsRegSealUsageApprovalDetail.vue?vue&type=style&index=0&id=65cd04a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cd04a2",
  null
  
)

export default component.exports